import React, {useCallback, useState} from 'react';
import type {ButtonProps} from '@mui/material';
import {Button} from '@mui/material';
import type {IconName} from '../icons/types';
import {Icon} from '../icons';

export type ActionButtonV2Props = Omit<ButtonProps, 'onClick'> & {
  onClick: () => Promise<void> | void;
  showSpinnerOnClick?: boolean;
  icon?: IconName;
};

export const ActionButtonV2: React.FC<ActionButtonV2Props> = ({
  showSpinnerOnClick,
  onClick,
  icon,
  disabled,
  loading,
  ...rest
}) => {
  const [handlingClick, setHandlingClick] = useState<boolean>(false);
  const handleClick = useCallback(() => {
    setHandlingClick(true);
    Promise.resolve(onClick()).finally(() => setHandlingClick(false));
  }, [onClick]);

  const busy = showSpinnerOnClick ? handlingClick : undefined;

  return (
    <Button
      {...rest}
      onClick={handleClick}
      disabled={disabled || handlingClick}
      loading={loading || busy}
      startIcon={icon ? <Icon icon={icon} /> : rest.startIcon}>
      {rest.children ?? rest.title}
    </Button>
  );
};
